import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import DashboardChart from './SimChart'
import img2 from '../../assets/images/ui-images/image-circle.jpg';
import ChartistTooltip from "chartist-plugin-tooltips-updated";

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cadminList: []
        }
   }
    componentDidMount() {
        this.getTotalCAdmin();
    }
    getTotalCAdmin = () => {
        var data = {
            simulanis_id: ud.id
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/corporatesList`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.corporatesList) {
                        _this.setState({ cadminList: response.data.corporatesList });
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalCAdmin();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    render() {
        let pieOptions = {
            showLabel: false,
            ignoreEmptyValues: false,
            plugins: [ChartistTooltip({ appendToBody: true })]
        };
        let lineChartOptions = {
            showArea: true,
            showLine: false,
            showPoint: true,
            plugins: [
                ChartistTooltip({
                    appendToBody: true
                })
            ]
        };
        return (
            <div >
                <div className="xp-breadcrumbbar">
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <h4 className="xp-page-title">Dashboard</h4>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <div className="xp-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i className="icon-home"></i></a></li>
                                    {/* <li className="breadcrumb-item active" aria-current="page">Dashboard</li> */}
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xp-contentbar" >
                    <div className="row">
                        <div className="col-12">
                            <div className="dash_grid">
                                {this.state.cadminList.map((list, index) =>

                                    <div className="card bg-white">
                                        <div className="card-body">
                                            <div className="xp-widget-box">
                                                <div className="f_left">
                                                    <h4 className="xp-counter text-dark">{list.cooperate_name}</h4>
                                                    <hr />
                                                    <p className="mb-1 font-16 text-dark"><i className="mdi mdi-email-outline mr-2"></i>: {list.email}</p>
                                                    <p className="mb-1 font-16 text-dark"><i className="mdi mdi-phone mr-2"></i>: {list.phone}</p>
                                                    {/* <p className="mb-1 font-16 text-dark"><strong>Licence expire on:</strong> Dec-2023</p> */}
                                                </div>
                                                <div className="f_right">
                                                    <div style={{ backgroundColor: "rgb(185 49 47)" }} className="xp-widget-icon xp-widget-icon-bg img-responsive img-circle">
                                                        <img src={`${SERVER_IP}/icons/${list.cooperate_logo}`} className="rounded-circle" />
                                                        {/* <span>4.5 <i className="fa fa-star text-warning"></i></span> */}
                                                    </div>
                                                </div>
                                                <div className="clearfix"></div>
                                                {/* <div className="m-t-20">
                                                <p><strong>26GB of 30 GB used</strong></p>
                                                <div className="progress" style={{ height: "5px" }}>
                                                    <div className="progress-bar bg-danger" role="progressbar" style={{ width: "90%" }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div> */}

                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <DashboardChart />

                </div>
            </div>
        )
    }
}
export default Dashboard